import React from "react";
import Container from "react-bootstrap/Container";

function Datenschutz() {
  return (
    <div className="hero-container">
      <Container
        className="py-5"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          borderRadius: "10px",
          color: "black",
        }}
      >
        <h1 className="text-center mb-4">Datenschutz</h1>
        <p>
          Wir, die Grüne Wege GmbH, nehmen den Schutz Ihrer persönlichen Daten
          sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und
          entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung.
        </p>

        <h3>1. Verantwortliche Stelle</h3>
        <p>
          Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten ist:
        </p>
        <p>
          Grüne Wege GmbH<br />
          Musterstraße 123<br />
          12345 Musterstadt<br />
          Telefon: +49 123 456 789<br />
          E-Mail: info@gruenewege.de
        </p>

        <h3>2. Datenerhebung und -verarbeitung</h3>
        <p>
          Wir erheben personenbezogene Daten, wenn Sie uns diese im Rahmen einer
          Kontaktaufnahme (z. B. per Kontaktformular oder E-Mail) freiwillig
          mitteilen. Die erhobenen Daten werden ausschließlich zur Bearbeitung
          Ihrer Anfrage verwendet.
        </p>

        <h3>3. Cookies</h3>
        <p>
          Unsere Website verwendet Cookies. Cookies sind kleine Textdateien,
          die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert.
          Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und
          sicherer zu machen.
        </p>

        <h3>4. Ihre Rechte</h3>
        <p>
          Sie haben das Recht, jederzeit Auskunft über die von uns über Sie
          gespeicherten Daten zu erhalten. Außerdem haben Sie das Recht auf
          Berichtigung, Sperrung oder Löschung dieser Daten.
        </p>

        <h3>5. Kontakt</h3>
        <p>
          Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:
        </p>
        <p>
          Grüne Wege GmbH<br />
          Musterstraße 123<br />
          12345 Musterstadt<br />
          Telefon: +49 123 456 789<br />
          E-Mail: datenschutz@gruenewege.de
        </p>

        <p>
          Diese Datenschutzerklärung wird regelmäßig aktualisiert, um den
          rechtlichen Anforderungen zu entsprechen.
        </p>
      </Container>
    </div>
  );
}

export default Datenschutz;